import QRCode from "react-qr-code"
import CustomDialog from "../../../core/components/ui/CustomDialog"
import EIDDetailsComponent from "../components/eID-details.component"

const EIDDetailsDialogComponent = ({open, handleClose, details, eIDQRCode}) => {
    return(
        <CustomDialog
            open={open}
            onClose={handleClose}
            title="Electronic ID"
            hasDividers={true}
            content={
                <EIDDetailsComponent details={details} eIDQRCode={eIDQRCode} />
            }
            maxWidth={"sm"}
            customStyles={{}}
        />
    )
}

export default EIDDetailsDialogComponent